// extracted by mini-css-extract-plugin
export var errorIcon = "_k9-1";
export var nameLogo = "_k9-0";